module.exports = __webpack_public_path__ + "img/9788958072591.96a95249.jpg";